import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('onboarding-tours', {
  library: 'onboarding-tours'
});